import React from 'react';
import {
  SolutionPremiumContent,
  SolutionSubPageLayout,
  getSolutionSubpage,
} from '../features/solutions';

export const SmartHouse: React.FC = () => {
  const config = getSolutionSubpage('smart-house');
  return (
    <SolutionSubPageLayout config={config}>
      <SolutionPremiumContent config={config} />
    </SolutionSubPageLayout>
  );
};
